import { OpenAIOutlined, UploadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    Space,
    Spin,
    Typography,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { useState } from "react";
import axiosInstance from "../common/api";
import dayjs from "dayjs";
import { requiredField } from "../common/common";
import Title from "antd/es/skeleton/Title";
import { useNavigate } from "react-router-dom";
import DebounceSelect from "../common/DebounceSelect";

export default function () {
    const [pdfData, setPdfData] = useState();
    const [loadingAi, setLoadingAi] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [formInst] = Form.useForm();

    const onFinish = (form) => {
        const formData = new FormData();
        formData.append("file", form.file.file);
        setLoadingAi(true);
        axiosInstance
            .post("fine/ai", formData, { headers: { "Content-Type": "multipart/form-data" } })
            .then(({ data }) =>
                formInst.setFieldsValue({
                    ...data.ai,
                    attachment: data.attachmentId,
                    date: dayjs(data.ai.date),
                }),
            )
            .finally(() => {
                setLoadingAi(false);
                setPdfData(window.URL.createObjectURL(form.file.file));
            });
    };
    const onCreateFineSubmit = (form) => {
        setLoading(true);
        axiosInstance
            .post("fine", { ...form, date: form.date.format("YYYY-MM-DD") })
            .then(({ data }) => navigate(`/fines/${data.id}`, { replace: true }))
            .finally(() => setLoading(false));
    };
    return (
        <div>
            <Spin description="Sto analizzando il contenuto..." spinning={loadingAi}>
                {!pdfData && (
                    <Form onFinish={onFinish} style={{ width: 400 }}>
                        <Form.Item
                            label={"File"}
                            name="file"
                            valuePropName={"file"}
                            rules={[requiredField]}
                        >
                            <Dragger
                                accept={"application/pdf"}
                                maxCount={1}
                                onRemove={() => false}
                                beforeUpload={() => false}
                            >
                                <p>
                                    Trascina qui il file o clicca per selezionare (Solo file pdf
                                    accettati)
                                </p>
                            </Dragger>
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit" icon={<OpenAIOutlined />}>
                                Analizza con AI
                            </Button>
                        </Form.Item>
                    </Form>
                )}
                {pdfData && (
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <iframe src={pdfData} style={{ width: "100%", height: 700 }}>
                                ciao
                            </iframe>
                        </Col>
                        <Col span={12}>
                            <Typography.Title level={4}>Dati</Typography.Title>
                            <Form layout="vertical" form={formInst} onFinish={onCreateFineSubmit}>
                                <Space>
                                    <Form.Item
                                        label="Numero verbale"
                                        name="docNumber"
                                        rules={[requiredField]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Data verbale"
                                        name="date"
                                        rules={[requiredField]}
                                    >
                                        <DatePicker format="DD/MM/YYYY" />
                                    </Form.Item>

                                    <Form.Item label="Targa" name="licensePlate">
                                        <Input />
                                    </Form.Item>
                                </Space>

                                <Form.Item
                                    label="Breve descrizione"
                                    name="description"
                                    rules={[requiredField]}
                                >
                                    <Input.TextArea />
                                </Form.Item>

                                <Space>
                                    <Form.Item label="Importo ridotto" name="reducedAmount">
                                        <InputNumber
                                            decimalSeparator=","
                                            controls={false}
                                            precision={2}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label="Importo intero"
                                        name="fullAmount"
                                        rules={[requiredField]}
                                    >
                                        <InputNumber
                                            decimalSeparator=","
                                            controls={false}
                                            precision={2}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Importo pagato"
                                        name={"amountPaid"}
                                        rules={[requiredField]}
                                    >
                                        <Select
                                            options={[
                                                { label: "Nessuno", value: "NONE" },
                                                { label: "Ridotto", value: "REDUCED" },
                                                { label: "Intero", value: "FULL" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Space>

                                <Form.Item
                                    name={"assignedTo"}
                                    label="Assegnato a"
                                    rules={[requiredField]}
                                >
                                    <DebounceSelect
                                        style={{ maxWidth: 300 }}
                                        labelInValue={false}
                                        fetchOptions={async (query) =>
                                            axiosInstance
                                                .get("user", {
                                                    params: { query, page: 0, pageSize: 99999 },
                                                })
                                                .then(({ data }) =>
                                                    data.data.map((x) => ({
                                                        label: x.firstName + " " + x.lastName,
                                                        value: x.id,
                                                    })),
                                                )
                                        }
                                    />
                                </Form.Item>
                                <Form.Item name={"comment"} label="Commento">
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item name="attachment" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item style={{ textAlign: "end" }}>
                                    <Button htmlType="submit" type="primary" loading={loading}>
                                        Salva
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                )}
            </Spin>
        </div>
    );
}
